module.exports = __webpack_public_path__ + "static/img/invatejoin.9ddaa6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/invatejoin.png
// module id = OvKd
// module chunks = 0